<div class="bottom-panel-editor">
  <div class="bottom-panel-editor__header">
    <span class="bottom-panel-editor__header-title">
      <ng-content select="[slot=title]"></ng-content>
    </span>
    <ng-content select="[slot=headerActions]"></ng-content>
  </div>

  <div class="bottom-panel-editor__editor">
    <div class="bottom-panel-editor__editor__toolbar"></div>

    <div class="bottom-panel-editor__editor__container">
      <ckeditor [id]="'ckeditor'" [config]="config" [editor]="editor" [formControl]="control" [ngClass]="'textarea'" (ready)="onReady($event)"></ckeditor>
    </div>
  </div>

  <ng-content select="[slot=content]"></ng-content>

  <div class="bottom-panel-editor__footer">
    <span class="bottom-panel-editor__footer-content">
      <ng-content select="[slot=footerContent]"></ng-content>
    </span>
    <span class="bottom-panel-editor__footer-actions">
      <ng-content select="[slot=footerActions]"></ng-content>
    </span>
  </div>
</div>
